import React, { useEffect, useState } from "react";

import {
  getProjectSurveys,
  getUserPersonalData,
  updateUserPersonalData,
  postUserSurvey,
} from "../Code/api";

import Input from "../Code/Input";
import { Select } from "../Code/Select";
import { sortArray } from "../Code/utils";
import RadioButtonGroup from "../Code/RadioButtonGroup";
import RadioButtonTable from "../Code/RadioButtonTable";

import styles from "./styles.module.scss";

const genderOptions = [
  {
    id: 0,
    label: "männlich",
  },
  {
    id: 1,
    label: "weiblich",
  },
  {
    id: 2,
    label: "divers",
  },
];

const COUNTRIES = {
  Switzerland: {
    value: "CH",
    german: "Schweiz",
    english: "Switzerland",
  },
  Serbia: {
    value: "RS",
    german: "Serbien",
    english: "Serbia",
  },
};

const GERMAN_COUNTRY_OPTIONS = Object.values(COUNTRIES).map((c) => ({
  value: c.value,
  text: c.german,
}));

const OLDEST_YEAR_OF_BIRTH = 1922;
const YOUNGEST_YEAR_OF_BIRTH = 2015;

let yersOfBrth = [];
for (let i = YOUNGEST_YEAR_OF_BIRTH; i >= OLDEST_YEAR_OF_BIRTH; i--) {
  yersOfBrth.push({ value: i, text: `${i}` });
}

const YEARS_FOR_BIRTH = yersOfBrth;

const CodeSurvey = () => {
  const [survey, setSurvey] = useState({});
  const [surveyNotExist, setSurveyNotExist] = useState(false);
  const [userData, setUserData] = useState({});
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);

  const [code, setCode] = useState("");
  const [userJWT, setUserJWT] = useState("");
  const [surveyId, setSurveyId] = useState("");

  useEffect(() => {
    const indexOfProjectCode = window.location.pathname.lastIndexOf("code/");
    const indexOfSurvey = window.location.pathname.lastIndexOf("survey/");

    const code = window.location.pathname.substring(
      indexOfProjectCode + 5,
      indexOfSurvey - 1
    );
    const surveyId = +window.location.pathname.substring(indexOfSurvey + 7);

    let params = new URL(document.location).searchParams;
    let jwt = params.get("jwt");

    if (!jwt) {
      return;
    }

    setCode(code);
    setSurveyId(surveyId);
    setUserJWT(jwt);
  }, []);

  useEffect(() => {
    if (code && userJWT && surveyId) {
      fetchSurvey();
    }
  }, [code, userJWT, surveyId]);

  const populateDefaultCountry = async () => {
    await onPersonalInputBlur("country", COUNTRIES.Switzerland.value);
  };

  const fetchSurvey = async () => {
    if (!userJWT) {
      // todo add fetching JWT from the mobile
      window.location.href = "/sign-in";
    }

    const res = await getProjectSurveys(userJWT, code);
    const data = res.data ? res.data.data : [];

    const survey = data.surveys.find((s) => s.id === surveyId);
    const countryOptions = GERMAN_COUNTRY_OPTIONS;

    const userRes = await getUserPersonalData(userJWT);
    if (userRes.data && userRes.data.data) {
      setUserData(userRes.data.data);

      if (!userRes.data.data.country) {
        await populateDefaultCountry();
      } else {
        const selectedCountry = countryOptions.find(
          (c) => c.value === userRes.data.data.country
        );
        const selectedYear = YEARS_FOR_BIRTH.find(
          (c) => c.value === userRes.data.data.birthyear
        );
        setSelectedCountry(selectedCountry);
        setSelectedYear(selectedYear);
      }
    }

    setSurveyNotExist(!survey || !survey.id);
    setSurvey(survey);
    setCountryOptions(countryOptions);
  };

  const onInputBlur = (id, value) => {
    const reqData = {
      nextEntry: { id, value },
      type: "input",
    };

    updateUserData(reqData);
  };

  const onPersonalDataGenderChanged = async (reqData) => {
    onPersonalInputBlur("gender", reqData.nextEntry.id);
  };

  const onPersonalInputBlur = async (field, value) => {
    const newUserData = { ...userData, [field]: value };
    await updatePersonData(newUserData);
    setUserData(newUserData);

    if (field === "country") {
      const selectedCountry = countryOptions.find((c) => c.value === value);
      setSelectedCountry(selectedCountry);
    }

    if (field === "birthyear") {
      const selectedYear = YEARS_FOR_BIRTH.find((c) => c.value === value);
      setSelectedCountry(selectedYear);
    }
  };

  const updatePersonData = async (data) => {
    return await updateUserPersonalData(userJWT, data);
  };

  const updateUserData = async (reqData) => {
    const res = await postUserSurvey(userJWT, code, reqData);
    console.log("res", res);
  };

  if (surveyNotExist) {
    return <div>Survey does not exist</div>;
  }

  if (!survey || !survey.id) {
    return <div>Loading...</div>;
  }

  const sortedQuestions = sortArray(survey.questions, "order", "asc");
  const title = survey.html_title;
  const body = survey.html_body;

  return (
    <div className={styles.CodeSurvey}>
      <div className={styles.CodeSurvey__headerContainer}>
        <div className={styles.CodeSurvey__headerContent}>
          {/* <div className={styles.CodeSurvey__logo}>
						<img src={survey.logo} />
					</div> */}
          <h1 className={styles.CodeSurvey__title}>{title}</h1>
          <div
            className={styles.CodeSurvey__body}
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </div>
      </div>

      <div className={styles.CodeSurvey__questions}>
        <div className={styles.CodeSurvey__requiredContainer}>
          <span>*</span>Pflichtfelder
        </div>

        {/* STATIC QUESTIONS */}
        <RadioButtonGroup
          className={styles.CodeSurvey__singleQuestion}
          key="user-gender"
          name="user-gender"
          question={`Demografische Angaben: Was ist Dein Geschlecht?`}
          options={genderOptions}
          required={true}
          updateUserData={onPersonalDataGenderChanged}
          defaultOption={userData ? userData.gender : ""}
        />

        <div className={styles.CodeSurvey__singleQuestion}>
          <div className={styles.CodeSurvey__questionTitle}>
            <span>Demografische Angaben: Wie alt bist Du?</span>
            <span className={styles.CodeSurvey__requiredStar}>*</span>
          </div>
          <Select
            defaultValue={selectedYear}
            onSelectItem={(option) =>
              onPersonalInputBlur("birthyear", option.value)
            }
            noSelectedValue="Jahr"
            listItems={YEARS_FOR_BIRTH}
            containerClassName={styles.CodeSurvey__yearSelectContainer}
            className={styles.CodeSurvey__selectContent}
            listClassName={styles.CodeSurvey__selectList}
            itemClassName={styles.CodeSurvey__selectItem}
          />
        </div>

        <div className={styles.CodeSurvey__questionTitle}>
          <span>Demografische Angaben: Wo wohnst Du?</span>
          <span className={styles.CodeSurvey__requiredStar}>*</span>
        </div>
        <div className={styles.CodeSurvey__cityContainer}>
          <div className={styles.CodeSurvey__singleQuestion}>
            <div className={styles.CodeSurvey__questionTitle}>
              <span>PLZ</span>
            </div>
            <Input
              className={styles.CodeSurvey__inputShort}
              onBlur={(e) => onPersonalInputBlur("postcode", e.target.value)}
              defaultValue={userData.postcode}
            />
          </div>

          <div className={styles.CodeSurvey__singleQuestion}>
            <div className={styles.CodeSurvey__questionTitle}>
              <span>Ort</span>
            </div>
            <Input
              className={styles.CodeSurvey__inputMiddle}
              onBlur={(e) => onPersonalInputBlur("city", e.target.value)}
              defaultValue={userData.city}
            />
          </div>
        </div>

        {/* <div className={styles.CodeSurvey__singleQuestion}>
					<div className={styles.CodeSurvey__questionTitle}>
						<span>Country</span>
						<span className={styles.CodeSurvey__requiredStar}>*</span>
					</div>
					<Select
						defaultValue={selectedCountry}
						onSelectItem={option => onPersonalInputBlur('country', option.value)}
						noSelectedValue='- Choose country -'
						listItems={countryOptions}
						containerClassName={styles.CodeSurvey__selectContainer}
						className={styles.CodeSurvey__selectContent}
						listClassName={styles.CodeSurvey__selectList}
						itemClassName={styles.CodeSurvey__selectItem}
					/>
				</div> */}

        {sortedQuestions.map((question, index) => {
          const key = `questions-${index}`;

          if (question.type === "input") {
            return (
              <div className={styles.CodeSurvey__singleQuestion} key={key}>
                <div className={styles.CodeSurvey__questionTitle}>
                  <span>{question.question}</span>
                  {question.required && (
                    <span className={styles.CodeSurvey__requiredStar}>*</span>
                  )}
                </div>
                <Input
                  className={styles.CodeSurvey__input}
                  onBlur={(e) => onInputBlur(question.id, e.target.value)}
                  defaultValue={question.value.v || ""}
                />
              </div>
            );
          }

          if (question.type === "select") {
            return (
              <RadioButtonGroup
                className={styles.CodeSurvey__singleQuestion}
                key={key}
                name={key}
                question={`${question.question}`}
                options={question.options}
                required={question.required}
                updateUserData={updateUserData}
                defaultOption={question.value.id}
              />
            );
          }

          if (question.type === "table") {
            return (
              <RadioButtonTable
                className={styles.CodeSurvey__singleQuestion}
                key={key}
                name={key}
                question={question}
                required={question.required}
                updateUserData={updateUserData}
              />
            );
          }

          return <div key={key} />;
        })}
      </div>
    </div>
  );
};

export default CodeSurvey;
